import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericBoundedApiService, Response } from '@lsq-frontend/angular-shared/api-service';
import { RouteQueryParams, UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { GenericHealthService } from '@lsq-frontend/angular-shared/features/generic-get-services';

@Component({
    selector: 'lsq-backend',
    templateUrl: './lsq-backend.component.html'
})
export class LsqBackendComponent {
    public redirectUrl: string;
    protected logoutService: GenericBoundedApiService;
    protected logout$: Observable<Response>;

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _genericHealthService: GenericHealthService,
        private _router: Router,
        @Inject(SETTINGS) private _settings: ISettings
    ) {
        this._activatedRoute.queryParamMap.pipe(first()).subscribe(async (paramMap) => {
            this.redirectUrl = paramMap.get(RouteQueryParams.TargetUrl) || UiRoutes.Login;
            const address = paramMap.get(RouteQueryParams.Address);
            await this.forwardToBackend(address);
        });
    }

    private async forwardToBackend(address: string): Promise<void> {
        this._settings.httpApiServiceNameUrlMap = {
            compass: address || 'http://localhost:5000',
            dashboard: address || 'http://localhost:5000',
            financing: address || 'http://localhost:8080',
            reportCenter: address || 'http://localhost:3350',
            financingGql: address || 'http://localhost:3370'
        };

        await this._genericHealthService.executeOnce();
        await this._router.navigateByUrl(this.redirectUrl);
    }
}
